function SequenceReader(aSequenceTypeId) {
    this.__type = 'SequenceReader:www.veritracks.com';
    this.Id = -1;
    this.Sequence = aSequenceTypeId;
    //Public Enum SequenceTypeEnum
    //    Undefined = -1
    //    GlobalZone = 1
    //End Enum
}
if (typeof exports !== 'undefined') {
    module.exports = SequenceReader;
}